<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'HomeView',
})
</script>
<template>
  <DM ref="dm" />
</template>

<script setup lang="ts" name="HomeView">
// 基础导入
import { ref, h, reactive, onMounted, nextTick, computed } from 'vue'
import { Modal, Select, Tooltip, message, Checkbox, Input, DatePicker } from 'ant-design-vue'
const { Option } = Select
</script>
<style scoped>

</style>    